import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Card, CardBody, Button } from "reactstrap";

import { FilterOutlined } from "@ant-design/icons";
import {
  Button as AntdButton,
  Col as AntdCol,
  Row as AntdRow,
  DatePicker,
  Drawer,
  Form,
  Input,
  Select,
  Pagination,
  Space,
  Table,
} from "antd";
import { H5 } from "../../../../AbstractElements";
import { ClientApi } from "../../../../api";
import { fetchClients } from "../../../../api/client.api";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";

const Clients = (props) => {
  const { Option } = Select;
  const { TextArea } = Input;
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [clients, setClients] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [page, setPage] = useState(1);
  const [visible, setVisible] = useState(false);
  const [filterVisible, setFiltersVisible] = useState(false);
  const [sortBy, setSortBy] = React.useState("a-z");

  var formRef = useRef();
  const [editId, setEditId] = useState(null);

  const sortOptions = React.useRef([
    {
      value: "a-z",
      label: "Date ascending",
    },
    {
      value: "a-z",
      label: "Date descending",
    },
  ]);
  const getFormattedDate = (date) => {
    const formattedDate =
      // moment(date).format("ddd") +
      // " " +
      moment(date).format("MMM") +
      " " +
      moment(date).format("DD") +
      " " +
      moment(date).format("YYYY");

    return formattedDate;
  };
  const columns = [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
      width: 160,
    },
    {
      title: "Contact",
      key: "contact_phone",
      dataIndex: "contact_phone",
    },
    {
      title: "Email",
      key: "email",
      dataIndex: "email",
    },
    {
      title: "Created at",
      key: "created_time",
      render: (data) => <span>{getFormattedDate(data?.created_time)}</span>,
    },
    {
      title: "Source",
      key: "source",
      dataIndex: "source",
    },
  ];

  const getClients = (params) => {
    setLoading(true);
    fetchClients({ params: { ...params, page: page } }).then((res) => {
      setLoading(false);
      setTotalPages(res?.count ?? 10);
      setClients(res?.results ?? []);
    });
  };

  const onClose = () => {
    formRef.current.resetFields();
    setVisible(false);
  };

  useEffect(() => {
    getClients({});
  }, []);

  const addClient = () => {
    const updatedValues = formRef.current.getFieldsValue();
    console.log("updatedValues", updatedValues);
    const values = new FormData();
    values.append("name", updatedValues?.name ?? "");
    values.append("company_name", updatedValues?.company_name ?? "");
    values.append("user_type", updatedValues?.user_type ?? "");
    values.append("email", updatedValues?.email ?? "");
    values.append("alternate_contact", updatedValues?.alternate_contact ?? "");
    values.append("alternate_email", updatedValues?.alternate_email ?? "");
    values.append("contact_phone", updatedValues?.contact_phone ?? "");
    values.append("bnpl_active", updatedValues?.bnpl_active ?? "");
    values.append("created_time", updatedValues?.created_time ?? "");
    values.append("source", updatedValues?.source ?? "");
    // if (editId) {
    //   axios
    //     .put(`${ClientApi}${editId}/`, values)
    //     .then((res) => {
    //       toast.success("Client Edited");
    //       onClose();
    //     })
    //     .catch((error) => {
    //       if (error?.response?.status == 405) {
    //         toast.error(error?.response?.data);
    //       }
    //     });
    //   setEditId(null);
    // } else {
    axios
      .post(`${ClientApi}`, values)
      .then((res) => {
        fetchClients({});
        toast.success("Client Added");
        onClose();
      })
      .catch((error) => {
        if (error?.response?.status == 405) {
          toast.error(error?.response?.data);
        }
      });
    // }
  };
  useEffect(() => {
    console.log("getClients", page);
    getClients({});
  }, [page]);

  return (
    <section>
      <Card>
        <CardBody>
          <div class="d-flex align-center justify-content-between w-100 mb-2">
            <H5>Clients</H5>
            <Space>
              <Button
                onClick={() => {
                  setFiltersVisible(true);
                }}
              >
                Filters
              </Button>
              <Button
                onClick={() => {
                  setVisible(true);
                }}
              >
                Create Client
              </Button>
              <Input.Search
                type="text"
                style={{ maxWidth: 180 }}
                placeholder="Search"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onSearch={(value) => {
                  getClients({ search: search });
                }}
              />
            </Space>

            {filterVisible ? (
              <div>
                <Select
                  placeholder="Sort By"
                  value={sortBy}
                  onChange={(value) => {
                    setSortBy(value);
                  }}
                >
                  {sortOptions.current.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
                <Select
                  placeholder="Sort By"
                  value={sortBy}
                  onChange={(value) => {
                    setSortBy(value);
                  }}
                >
                  {sortOptions.current.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            ) : (
              <></>
            )}
          </div>

          <Table
            columns={columns}
            loading={loading}
            dataSource={clients}
            pagination={false}
            rowKey={"id"}
          />

          <Pagination
            current={page}
            total={totalPages}
            showSizeChanger={false}
            pageSize={10}
            className="mt-3"
            onChange={(p) => {
              console.log("Pagination", p);
              setPage(p);
            }}
          />
        </CardBody>
      </Card>

      <Drawer
        title="Create Client"
        width={500}
        onClose={() => {
          onClose();
        }}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <AntdButton
              onClick={() => {
                onClose();
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </AntdButton>
            <AntdButton
              className="btn btn-primary"
              form="ClientForm"
              type="primary"
              htmlType="submit"
            >
              Submit
            </AntdButton>
          </div>
        }
      >
        <Form
          layout="vertical"
          id="ClientForm"
          ref={formRef}
          onFinish={addClient}
        >
          <AntdRow gutter={24}>
            <AntdCol sm={12}>
              <Form.Item
                name={"name"}
                label="Client name"
                rules={[
                  {
                    required: true,

                    message: "Client name is required",
                  },
                ]}
              >
                <Input placeholder="Client name" />
              </Form.Item>
            </AntdCol>
            <AntdCol sm={12}>
              <Form.Item name={"company_name"} label="Company Name">
                <Input placeholder="Company Name" />
              </Form.Item>
            </AntdCol>
            {/* <AntdCol sm={12}>
              <Form.Item name={"branch"} label="Branch">
                <Select
                  defaultValue={props?.settings?.branch?.id}
                  placeholder="Select Branch"
                >
                  {branchOption}
                </Select>
              </Form.Item>
            </AntdCol> */}
          </AntdRow>

          <AntdRow gutter={24}>
            <AntdCol sm={12}>
              <Form.Item name={"email"} label="Email">
                <Input placeholder="Enter Email" />
              </Form.Item>
            </AntdCol>
            <AntdCol sm={12}>
              <Form.Item
                name={"contact_phone"}
                label="Contact Number"
                rules={[
                  {
                    required: true,
                    pattern: /^[0-9]{10}$/,
                    message: "Enter a valid 10 digit contact number",
                  },
                ]}
              >
                <Input
                  showCount
                  maxLength={10}
                  minLength={10}
                  placeholder="Enter contact number"
                />
              </Form.Item>
            </AntdCol>
          </AntdRow>
          <AntdRow gutter={24}>
            <AntdCol sm={12}>
              <Form.Item name={"source"} label="Source">
                <Input placeholder="Enter source" />
              </Form.Item>
            </AntdCol>

            <AntdCol sm={12}>
              <Form.Item name={"created_time"} label="Created date">
                <DatePicker placeholder="Created date" className="w-100" />
              </Form.Item>
            </AntdCol>
          </AntdRow>
        </Form>
      </Drawer>
    </section>
  );
};

const mapStateToProps = ({ dispatch, settings }) => {
  return {
    dispatch,
    settings,
  };
};

export default connect(mapStateToProps)(Clients);
